import {BrowserRouter, Route, Switch, useHistory} from "react-router-dom";
import React from "react";
import Page1 from "../pages/Page1";
import Page2 from "../pages/Page2";
import Page3 from "../pages/Page3";
import Page4 from "../pages/Page4";
function Routers() {
    return (<BrowserRouter basename="/demo/report">
            <Switch>
                <Route  exact path="/">
                    <Page1/>
                </Route>
                <Route  exact path="/page2">
                    <Page2/>
                </Route>
                <Route  exact path="/result">
                    <Page3/>
                </Route>
                <Route exact path="/disclaimer">
                    <Page4/>
                </Route>

            </Switch>
        </BrowserRouter>
    )
}

export default Routers
